// React hook useFetch() that returns a function fetchWithAuth() that we can use througout React app
//   Note using/destructuring useAuth() in the top level of the hook allows us to 
//   access useful Auth0 functions and variables from within our function
//   and we can now do this without breaking the rules of React hooks

// Detect user no longer authorised logic
//  Get X-Project-ID from request, get konsol_roles from token
//  If X-Project-ID value (project name) not in konsol_roles item (structured Konsol.{project_name}.{role}), log user out
//  else continue with request
import { useAuth0 } from "@auth0/auth0-react";

export function useFetch() {
    
    const { getAccessTokenSilently, user, isAuthenticated, logout } = useAuth0();

    return async function fetchWithAuth(url, options){

        let project = options.headers['X-Project-ID']
        let token = null
        if (isAuthenticated && user){
            try {
                // If we have a valid token in memory, use it. Otherwise get a new one from Auth0
                token = await getAccessTokenSilently({authorizationParams: { project }});

            } catch (e) {
                // Triggers if refresh token cannot be used - eg, max refresh token lifetime has been reached (as of 30Jun2025 this is 2-3 days),
                //  or if user deleted from Auth0 completely
                logout({ returnTo: window.location.origin });
            }
        }

        // The code calling fetchWithAuth may use the Headers class for its headers
        // which requires us to .append any additions
        if (options.headers instanceof Headers){
            options.headers.append('Authorization', `Bearer ${token}`)
        }else{
            options.headers = {...options.headers, 'Authorization': `Bearer ${token}`}
        }

        const response = await fetch(url, options)
        return (response)

    }
    

}